import InventoryItemsTableSkeleton from './InventoryItemsTableSkeleton/InventoryItemsTableSkeleton'
import TableBody from './TableBody/TableBody'
import TableHeader from './TableHeader/TableHeader'
import * as Styles from './styles'

const InventoryItemsTable = ({ loading, products, onClickInItem, currency, selectedProducts, onCheckProduct }) => {
  if (loading) return <InventoryItemsTableSkeleton />

  return (
    <Styles.TableContainer>
      <Styles.Table>
        <TableHeader />
        <TableBody
          products={products}
          onClickInItem={onClickInItem}
          currency={currency}
          selectedProducts={selectedProducts}
          onCheckProduct={onCheckProduct}
        />
      </Styles.Table>
    </Styles.TableContainer>
  )
}

export default InventoryItemsTable
